import { Fragment } from 'react'
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom'
import { DevOverlay } from '../../common/devOverlay'
import { ScrollWrapper } from '../../state/scrollState/scrollWrapper'
import { userPrefShowDevOverlay } from '../../state/userPrefsState/userPrefsSignels'
import { GlobalRouter } from '../globalRouter/globalRouter'
import { ScrollToTop } from '../layout/scrollToTop'
import { DevRoutes } from './devRoutes'
// Splits the routes into two, one for the dev menu and one for the rest of the app
// we want to avoid providers dependencies in the dev menu
export const DevRoutesSplit = (props: { children: React.ReactNode }) => {
    return (
        <Fragment>
            {/* This is for the dev window. should only ever be set for dev and test. never prod... */}
            {userPrefShowDevOverlay.value === 'dev' && <DevOverlay />}
            <Router>
                <ScrollToTop />
                <GlobalRouter>
                    <ScrollWrapper>
                        <Routes>
                            <Route path="/devMenu/*" element={<DevRoutes />} />
                            <Route path="/*" element={props.children}></Route>
                        </Routes>
                    </ScrollWrapper>
                </GlobalRouter>
            </Router>
        </Fragment>
    )
}
